import { createStore } from "vuex"

import { default as filters } from "./modules/filters"
import { default as alerts } from "./modules/alerts"
import { default as local } from "./modules/local"
import { default as user } from "./modules/user"
import { default as pref } from "./modules/pref"
//
import { default as session } from "./modules/session"

export default createStore({
	modules: {
		// persistent
		filters,
		alerts,
		local,
		user,
		pref,

		// volatile
		session,
	},
	state: {},
	mutations: {},
	actions: {},
	getters: {},
})
